import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { isFocusedOtherCampaignVisible } from 'mini-mail-campaign-view/lib/util/focusedOtherCampaignUtils';
import { isInsideIframe } from 'dom-utils/lib/utils/isInsideIframe';
import { shouldShowFocusedOtherButton } from './shouldShowFocusedOtherButton';

/**
 * Utility to determine if the focused other campaign is to be shown or not
 */
export const canShowFocusedOtherCampaign = () =>
    shouldShowFocusedOtherButton() &&
    getListViewStore().canAllotSpaceForFocusedOtherCampaign &&
    isFocusedOtherCampaignVisible() &&
    !isInsideIframe();
